import React from 'react'

function ID1() {
    return (
        <div className="servicePage_item">
            <h1 className="servicePage_title">КОМПЛЕКСНАЯ АВТОМАТИЗАЦИЯ</h1>
            <div className="content" readonly=""><p>
                «1С:Комплексная автоматизация» — это программа для построения на предприятии единой
                информационной системы, охватывающей основные задачи управления и учета. Данное решение позволяет
                автоматизировать важнейшие области бизнеса: бухгалтерию, торговлю, склад, расчет зарплаты, кадровый
                учет.
            </p>
                <p>
                    Использование инструментов прикладного решения позволяет обеспечить слаженную работу как
                    подразделений внутри организации, так и с внешним окружением (клиенты, поставщики, конкуренты).<br/>
                </p>
                <h3>Назначение программы «1С:Комплексная автоматизация»</h3>
                <p>
                    Программа ориентирована на использование в сфере малого и среднего бизнеса:
                    в торговых предприятиях, на небольших производствах, в компаниях, оказывающих услуги.
                    «1С:Комплексная автоматизация» наилучшим образом подойдет тем компаниям, которые используют
                    в настоящий момент несколько отдельных продуктов, а также тем, чьи потребности
                    в управлении и учете превысили возможности имеющихся информационных систем.
                </p>
                <ul>
                </ul>
                <p>
                    По мере изменения требований бизнеса и законодательства этот продукт может быть
                    перенастроен, расширен за счет более полного использования функционала, интеграции
                    с другими приложениями на платформе «1С:Предприятие 8» и с другими решениями.
                </p>
                <h3>Сценарии внедрения «1С:Комплексная автоматизация»</h3>
                <p>
                    Этот программный продукт позволяет организации выбрать наиболее удобный для себя вариант его
                    внедрения, в соответствии с задачам и планам в текущей ситуации.
                </p>
                <p>
                    <b>Замена нескольких продуктов на современное интегрированное решение.</b> «1С:Комплексная
                    автоматизация» необходима для замены используемых комплексных решений предыдущих версий. Современный
                    программный продукт нового поколения позволит наиболее эффективно провести автоматизацию рабочих
                    процессов и реализовать оптимальную политику ее проведения.
                </p>
                <p>
                    <b>Поэтапное развитие информационной системы предприятия.</b> Программа обеспечивает поэтапное
                    развитие информационной системы предприятия — от решения первоочередных задач
                    на основе отдельных приложений или их связанных комплексов к созданию единой
                    информационной системы предприятия на основе «1С:Комплексная автоматизация 2».
                </p>
                <p>
                    <b>Автоматизация отдельных задач.</b> С помощью программ «1С:Предприятие 8», входящих
                    в состав продукта, можно автоматизировать наиболее важные рабочие задачи или использовать
                    другие, удобные для предприятия варианты.
                </p></div>



        </div>
    )
}

export {ID1}
